import { render, staticRenderFns } from "./deleteChannel.vue?vue&type=template&id=7afec71b&"
import script from "./deleteChannel.vue?vue&type=script&lang=js&"
export * from "./deleteChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports